// login.js

import {
  getService,
  postService
} from '../api/service.js'
/**
 * name 登录
 * time 2021-09-07
 * param userName String 账号
 * param password String 密码
 * return String token
 * */
// 一级分销商列表
export const adminGetDistributorListPost = params => {
  return postService('/api/jfy/adminGetDistributorList', params)
}
// 上下线
export const adminDistributorUpdateStatusPost = params => {
  return postService('/api/jfy/adminDistributorUpdateStatus', params)
}
// 一级分销商充值记录
export const distrbutorRechargeRecordPost = params => {
  return postService('/api/distributor/distrbutorRechargeRecord', params)
}
// 一级分销商详情
export const getDistributorInfoPost = params => {
  return postService('/api/distributor/getDistributorInfo', params)
}
// 修改一级分销商
export const updateDistributorPost = params => {
  return postService('/api/distributor/updateDistributor', params)
}
// 添加一级分销商
export const addDistributorPost = params => {
  return postService('/api/distributor/addDistributor', params)
}
// 重置一级密码
export const resetDistributorPwdPost = params => {
  return postService('/api/jfy/resetDistributorPwd', params)
}
// 二级分销商列表
export const getDistrbutorTwoListPost = params => {
  return postService('/api/distributor/getDistrbutorTwoList', params)
}
// 二级修改状态
export const adminDistributorTwoUpdateStatusPost = params => {
  return postService('/api/jfy/adminDistributorTwoUpdateStatus', params)
}
// 一级分销商授权二级分销商
export const impowerDistrbutorTwoPost = params => {
  return postService('/api/distributor/impowerDistrbutorTwo', params)
}
// 一级分销商授权二级分销商
export const cancelImpowerDistrbutorTwoPost = params => {
  return postService('/api/distributor/cancelImpowerDistrbutorTwo', params)
}
// 二级分销商详情
export const adminGetDistributorTwoInfoPost = params => {
  return postService('/api/jfy/adminGetDistributorTwoInfo', params)
}
// 修改二级分销商
export const adminUpdateDistributorTwoPost = params => {
  return postService('/api/jfy/adminUpdateDistributorTwo', params)
}
// 添加二级分销商
export const adminAddDistributorTwoPost = params => {
  return postService('/api/jfy/adminAddDistributorTwo', params)
}

/**
 * name 登出
 * time 2021-09-07
 * */
export const codeGet = params => {
  return getService('/api/auth/getCaptcha', params)
}

// 一级分销商免登录

export const jfyDistributorLogin = params => {
  return postService('api/jfy/jfyDistributorLogin', params)
}
// 二级免登录
export const jfyDistributorTwoLogin = params => {
  return postService('api/jfy/jfyDistributorTwoLogin', params)
}

// 二级分销商修改密码
export const resetDistributorTwoPwd = params => {
  return postService('api/jfy/resetDistributorTwoPwd', params)
}
